export const subscriptionStatus = {
  ACTIVE: 10,
  PENDING: 20,
  SUSPENDED: 30,
  TERMINATED: 40,
  CANCELLED: 50,
  ORDERED: 60,
  ID_STATE_DISBARRED: 70,
};

export const userProductId = 10;
